@if (formGroup && filters && filters.length > 0) {
<div>
  <form (ngSubmit)="onFilter()" [formGroup]="formGroup" class="flex flex-col gap-3">
    @for (filter of filters; track filter) {
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>{{ filter.label[lang] }}</mat-label>
      <mat-select [formControlName]="filter.filterKey" multiple>
        @for (item of filter.items; track item) {
        <mat-option [value]="item.value">{{ item.label[lang] }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    }
    <div class="flex justify-between">
      <button (click)="filter.emit({})" class="primary-button" mat-button type="button">
        {{ 'personal_content.coop.filter.reset' | transloco }}
      </button>
      <button class="primary-button" mat-button type="submit">
        {{ 'personal_content.coop.filter.submit' | transloco }}
      </button>
    </div>
  </form>
</div>
}
